

import React, { useState } from "react";
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import BenefitsAvailable from "./BenefitsAvailable";
import BenefitsCreate from "./BenefitsCreate";
import BenefitsDetails from "./BenefitsDetails";



const BenefitsTabs = () => {
  const [tabs, setTabs] = useState([{ label: "All Benefits", component: "allBenefits" },{ label: "+ Add Benefits", component: "addBenefits" }]);
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to Add a New Warehouse Tab
  const handleAddTab = (exercise) => {
    const existingTab = tabs.find((tab) => tab.id === exercise.id);
    if (!existingTab) {
      setTabs([...tabs, { id: exercise.id, label: exercise.benefit_name, component: "benefitsDetails", data: exercise }]);
      setSelectedTab(tabs.length);
    } else {
      setSelectedTab(tabs.findIndex((tab) => tab.id === exercise.id));
    }
  };

  const handleCloseTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    
    if (index === selectedTab) {
      if (newTabs.length > 2) {
        setSelectedTab(Math.max(0, index - 1)); // Move to previous tab if available
      } else {
        setSelectedTab(0); // Reset to "All Exercises" if only default tabs remain
      }
    }
  
    setTabs(newTabs);
  };
  
  return (
    <Box sx={{ width: "100%" }}>
      {/* MUI Tabs */}
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{tab.label}</Typography>
                {index > 1 && (
                  <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ ml: 1 }}>
                    <Close fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {tabs[selectedTab].component === "allBenefits" && <BenefitsAvailable onExerciseClick={handleAddTab} />}
        {tabs[selectedTab].component === "addBenefits" && <BenefitsCreate />}
        {tabs[selectedTab].component === "benefitsDetails" && <BenefitsDetails benefits={tabs[selectedTab].data} />}
      </Box>
    </Box>
  );
};

export default BenefitsTabs;
